import { useFormikContext } from 'formik';
import React from 'react';

import Icon from '@components/Icon/Icon';

import { useCuration } from '@hooks/useCuration';
import { useRecordFlags } from '@hooks/useRecordFlags';

export default function CurationDrilldownEditButton() {
  const {
    state: { isCreating, isEditing, record },
    startEditingRecord,
    stopEditingRecord,
  } = useCuration();
  const { canEdit } = useRecordFlags();

  const formik = useFormikContext<Record<string, unknown>>();

  if (!record || !canEdit) {
    return null;
  }

  return (
    <>
      {isCreating ? null : isEditing ? (
        <Icon
          clickable
          color="primary.contrastText"
          name="xmark"
          onClick={() => {
            stopEditingRecord();
            formik.resetForm();
          }}
          type="fas"
        />
      ) : (
        <Icon
          clickable
          color="primary.contrastText"
          name="pencil"
          onClick={() => {
            startEditingRecord();
          }}
          size="1x"
          type="fas"
        />
      )}
    </>
  );
}
